import React from 'react';
import { AxiosError } from 'axios';
import { Alert } from '@material-ui/lab';
import { Button, createStyles, Grid, Icon, makeStyles, Theme } from '@material-ui/core';

import ClassificationService from '../../../Services/ClassificationService';
import { HomeContext } from '../../Home/HomeContext';
import { ClassificationStatus } from '../enum/ClassificationStatus';
import { NewsContext } from '../NewsContext';

interface IRestoreClassificationProps {
    classificationStatus: ClassificationStatus,
    onRestore: () => void
}

const useStyles = makeStyles((theme: Theme) => createStyles({    
    informationBox: {
        margin: theme.spacing(2,0)
    },
}));

export function RestoreClassification({classificationStatus, onRestore}: IRestoreClassificationProps) {
    const classes = useStyles();
    
    const newsContext = React.useContext(NewsContext);
    const homeContext = React.useContext(HomeContext);

    const handleRestore = () => {
        homeContext.setOpenLoadingDialog(true);

        ClassificationService
            .updateClassificationStatus(newsContext.classification.id, newsContext.classification, ClassificationStatus.REVIEWED)
            .then(() => {
                homeContext.setOpenLoadingDialog(false);
                homeContext.showSuccess('Classificação restaurada com sucesso!');
                onRestore();
            })
            .catch((error: AxiosError) => {
                homeContext.setOpenLoadingDialog(false);
                homeContext.showError('', error);
            });
    };

    const getRemovedHint = () => {
        if (classificationStatus === ClassificationStatus.REMOVED) {
            return (
                <>
                    <Grid item>
                        <Alert severity="error" icon={<Icon>warning_amber</Icon>}>
                            Esta classificação foi removida
                        </Alert>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={handleRestore}
                            size="large">
                            RESTAURAR
                        </Button>
                    </Grid>
                </>
            );
        }
    };

    return (
        <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            className={classes.informationBox}>
            { getRemovedHint() }
        </Grid>
    );
}